import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface RatingHistoryPoint {
  date: string;
  rating: number;
  ratingBefore: number;
  ratingAfter: number;
  deviation: number;
  deviationBefore: number;
  deviationAfter: number;
  reliability: number;
  matchId: string;
  upperBound: number;
  lowerBound: number;
}

export function useRatingHistory(playerId?: string) {
  return useQuery({
    queryKey: ['rating-history', playerId],
    queryFn: async () => {
      if (!playerId) return [];

      const { data, error } = await supabase
        .from('match_results')
        .select(`
          id,
          created_at,
          rating_before,
          rating_after,
          rating_deviation_before,
          rating_deviation_after,
          reliability_before,
          reliability_after,
          match_id
        `)
        .eq('player_id', playerId)
        .order('created_at', { ascending: true });

      if (error) throw error;

      return (data || []).map((point): RatingHistoryPoint => ({
        date: point.created_at || '',
        rating: point.rating_after,
        ratingBefore: point.rating_before,
        ratingAfter: point.rating_after,
        deviation: point.rating_deviation_after,
        deviationBefore: point.rating_deviation_before,
        deviationAfter: point.rating_deviation_after,
        reliability: point.reliability_after,
        matchId: point.match_id,
        upperBound: point.rating_after + 1.96 * point.rating_deviation_after,
        lowerBound: point.rating_after - 1.96 * point.rating_deviation_after,
      }));
    },
    enabled: !!playerId,
  });
}
